import { render, staticRenderFns } from "./addtrailer.vue?vue&type=template&id=4faad1a4&scoped=true&"
import script from "./addtrailer.js?vue&type=script&lang=js&"
export * from "./addtrailer.js?vue&type=script&lang=js&"
import style0 from "./addtrailer.vue?vue&type=style&index=0&id=4faad1a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faad1a4",
  null
  
)

export default component.exports